module.exports = __webpack_public_path__ + "static/img/wImg.6caf9262.png";